/* Karmaseda · V1 Oro en Shopify. Misma lógica que la tienda local (sitio.js), conectada a los datos reales:
   cesta con /cart.js, /cart/add.js y /cart/change.js; buscador predictivo con /search/suggest.json;
   recomendaciones de la cesta con /recommendations/products.json; filtros nativos con la Section Rendering API. */
(function () {
  'use strict';
  var d = document, K = window.KS || {}, root = (K.root || '/').replace(/\/$/, '');
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || d).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  /* precio con el mismo formato que usa la tienda para la moneda activa (K.money = precio 1234,56 ya formateado por Shopify) */
  var MT = K.money || '€1.234,56', MM = MT.match(/1(\D?)234(\D)56/);
  function money(cents) {
    var n = (Number(cents) || 0) / 100, th = MM ? MM[1] : ',', dec = MM ? MM[2] : '.';
    var s = n.toFixed(2).split('.'), i = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    var num = i + dec + s[1];
    return MM ? MT.replace(MM[0], num) : num;
  }
  var img = function (src, w) { if (!src) return ''; src = src.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, ''); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var store = {
    get: function (k, def) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : def; } catch (e) { return def; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var ICON = {
    minus: '<svg class="ic ic-s" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg class="ic ic-s" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    trash: '<svg class="ic ic-s" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 7h15M9.5 7V4.8h5V7M6.5 7l.9 12.5h9.2L17.5 7M10.2 10.5v6M13.8 10.5v6"/></svg>',
    x: '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  /* ---------------- cabecera, menú, volver arriba ---------------- */
  var hdr = $('#hdr');
  function onScroll() {
    if (hdr) hdr.classList.toggle('is-scrolled', scrollY > 8);
    var tt = $('#toTop'); if (tt) tt.classList.toggle('on', scrollY > 600);
  }
  addEventListener('scroll', onScroll, { passive: true }); onScroll();
  var tt = $('#toTop'); tt && tt.addEventListener('click', function () { scrollTo({ top: 0, behavior: 'smooth' }); });

  var dr = $('#drawer'), om = $('#openMenu');
  function menu(open) {
    if (!dr) return;
    dr.classList.toggle('open', open); dr.setAttribute('aria-hidden', !open);
    om && om.setAttribute('aria-expanded', open); d.body.classList.toggle('menu-open', open);
  }
  om && om.addEventListener('click', function () { menu(true); });
  $('#closeMenu') && $('#closeMenu').addEventListener('click', function () { menu(false); });
  if (window.matchMedia && matchMedia('(hover:hover) and (min-width:990px)').matches) {
    $$('.has-sub').forEach(function (li) {
      var det = $('.nav-det', li), tm;
      li.addEventListener('mouseenter', function () { clearTimeout(tm); det.open = true; });
      li.addEventListener('mouseleave', function () { tm = setTimeout(function () { det.open = false; }, 120); });
    });
  }
  $$('.nav-det').forEach(function (det) {
    det.addEventListener('toggle', function () { if (det.open) $$('.nav-det').forEach(function (o) { if (o !== det) o.open = false; }); });
  });
  d.addEventListener('click', function (ev) {
    $$('.nav-det[open]').forEach(function (o) { if (!o.contains(ev.target)) o.open = false; });
    $$('.facet[open]').forEach(function (o) { if (!o.contains(ev.target) && !o.closest('.facets.is-open')) o.open = false; });
  });
  d.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    menu(false); cart(false); search(false); guide(false);
    $$('.nav-det[open]').forEach(function (o) { o.open = false; });
  });

  /* ---------------- aparición suave (nunca deja nada oculto) ---------------- */
  var io = null;
  function show(el) { el.classList.add('in'); }
  function reveal(scope) {
    var els = $$('.reveal:not(.in)', scope);
    if (!('IntersectionObserver' in window) || d.hidden) { els.forEach(show); return; }
    if (!io) io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { show(x.target); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    els.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight) show(el); }); }, 1500);
    setTimeout(function () { els.forEach(show); }, 6000);
  }
  reveal();
  d.addEventListener('visibilitychange', function () { if (!d.hidden) $$('.reveal').forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight) show(el); }); });

  /* ---------------- buscador (predictivo nativo de Shopify) ---------------- */
  var sm = $('#searchModal');
  function search(open) {
    if (!sm) return;
    sm.hidden = !open; d.body.classList.toggle('menu-open', open);
    if (open) { menu(false); setTimeout(function () { $('#SearchModalInput').focus(); }, 30); }
  }
  $$('[data-open-search]').forEach(function (b) { b.addEventListener('click', function () { search(true); }); });
  $$('[data-close-search]').forEach(function (b) { b.addEventListener('click', function () { search(false); }); });
  sm && sm.addEventListener('click', function (ev) { if (ev.target === sm) search(false); });
  var pi = $('#SearchModalInput'), pv = $('#predictive'), sq = 0, st;
  pi && pi.addEventListener('input', function () {
    var q = pi.value.trim(), my = ++sq;
    clearTimeout(st);
    if (!q) { pv.innerHTML = ''; return; }
    st = setTimeout(function () {
      fetch((K.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); }).then(function (j) {
          if (my !== sq) return;
          var r = (j.resources && j.resources.results && j.resources.results.products) || [];
          pv.innerHTML = r.length ? '<ul>' + r.map(function (p) {
            var pr = String(p.price).indexOf('.') > -1 ? Math.round(parseFloat(p.price) * 100) : Number(p.price);
            return '<li><a href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image && p.featured_image.url || p.image, 360)) + '" alt="" loading="lazy">' + esc(p.title) + '<br><strong>' + money(pr) + '</strong></a></li>';
          }).join('') + '</ul><a class="link pv-all" href="' + (K.search || '/search') + '?type=product&q=' + encodeURIComponent(q) + '">' + esc((K.t && K.t.search) || 'Ver todos los resultados') + '</a>' : '';
        }).catch(function () {});
    }, 180);
  });

  /* ---------------- cesta (API AJAX de Shopify) ---------------- */
  var cd = $('#cartDrawer'), CART = null, busy = false;
  function api(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return api(root + '/cart.js').then(function (c) { CART = c; render(); return c; }); }
  function lineHTML(x, i, cls) {
    var vt = x.variant_title && !x.product_has_only_default_variant ? x.variant_title : '';
    return '<li class="' + cls + '" data-id="' + x.key + '" data-line="' + (i + 1) + '"><a href="' + esc(x.url) + '"><img src="' + esc(img(x.image, 240)) + '" alt="' + esc(x.product_title) + '" loading="lazy"></a>' +
      '<div><a class="ci-t" href="' + esc(x.url) + '">' + esc(x.product_title) + '</a>' + (vt ? '<p class="ci-v notranslate" translate="no">' + esc(vt) + '</p>' : '') +
      '<div class="ci-row"><div class="qty"><button type="button" data-ci="-1" aria-label="Quitar una unidad de ' + esc(x.product_title) + '">' + ICON.minus + '</button>' +
      '<input type="number" min="0" max="99" value="' + x.quantity + '" aria-label="Cantidad" data-ci-q><button type="button" data-ci="1" aria-label="Añadir una unidad de ' + esc(x.product_title) + '">' + ICON.plus + '</button></div>' +
      '<button type="button" class="ci-rm" data-ci-rm aria-label="Eliminar ' + esc(x.product_title) + '">' + ICON.trash + '</button></div></div>' +
      '<p class="ci-p notranslate" translate="no">' + (x.original_line_price > x.final_line_price ? '<s class="ci-was">' + money(x.original_line_price) + '</s>' : '') + money(x.final_line_price) + '</p></li>';
  }
  /* Descuento por volumen (automático en Shopify): lo que se ahorra y cuánto falta para el siguiente tramo */
  var VOL = [[2, 10], [3, 15], [4, 20]];
  function volumen(c) {
    var n = c.item_count, ah = c.total_discount || 0, sig = null;
    for (var i = 0; i < VOL.length; i++) if (n < VOL[i][0]) { sig = VOL[i]; break; }
    var emp = !n ? '' : sig ? 'Añade ' + (sig[0] - n) + (sig[0] - n === 1 ? ' prenda más' : ' prendas más') + ' y ahorra un ' + sig[1] + ' %' : 'Tienes el descuento máximo: 20 %';
    $$('[data-ahorro]').forEach(function (e) { e.textContent = ah > 0 ? 'Ahorras ' + money(ah) : ''; e.hidden = !(ah > 0); });
    $$('[data-empuje]').forEach(function (e) { e.textContent = emp; e.hidden = !emp; });
    /* Barra de tramos del carrito (curso): 1 prenda = un poco, 2 = 10 %, 3 = 15 %, 4 o más = 20 % */
    var pg = $('[data-prog]');
    if (pg) {
      pg.hidden = !n;
      var pct = n <= 0 ? 0 : n === 1 ? 14 : Math.min(100, (n - 1) * 100 / 3);
      $('[data-prog-fill]', pg).style.width = pct + '%';
      $('[data-prog-t]', pg).textContent = !sig ? '¡Ya tienes el 20 % extra!' : 'Te falta ' + (sig[0] - n) + (sig[0] - n === 1 ? ' producto' : ' productos') + ' para un ' + sig[1] + ' % extra';
      $$('.cd-prog-paso', pg).forEach(function (p, i) { p.classList.toggle('on', n >= VOL[i][0]); });
    }
  }
  /* Curso: precio rebajado + tachado + "Ahorras X € (−N %)" cuando hay precio de comparación real */
  function ahorroTxt(pr, cp) { var a = cp - pr; return 'Ahorras ' + money(a) + ' (−' + Math.floor(a * 100 / cp) + ' %)'; }
  function priceHTML(pr, cp) {
    if (!(cp > pr)) return '<p class="price" translate="no"><span class="pr-now">' + money(pr) + '</span></p>';
    return '<p class="price is-sale" translate="no"><span class="pr-now">' + money(pr) + '</span> <s class="pr-was">' + money(cp) + '</s></p><p class="pr-ahorro notranslate" translate="no">Ahorra un ' + Math.floor((cp - pr) * 100 / cp) + '\u00a0%</p>';
  }
  function render() {
    var c = CART; if (!c) return;
    var n = c.item_count, t = c.total_price;
    volumen(c);
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    if (cd) {
      $('[data-cart-title]', cd).textContent = cd.getAttribute('data-t-title').replace('{{cart_quantity}}', n);
      $('[data-checkout-btn]', cd).textContent = cd.getAttribute('data-t-checkout').replace('{{total_price}}', money(t));
      $('[data-cart-subtotal]', cd).textContent = money(t);
      var br = $('[data-cart-bruto]', cd); if (br) br.textContent = money(c.original_total_price);
      var dr2 = $('[data-desc-row]', cd), dsc = c.total_discount || 0;
      if (dr2) { dr2.hidden = !dsc; $('[data-desc-amt]', dr2).textContent = '−' + money(dsc);
        var nms = []; (c.items || []).forEach(function (x) { (x.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title; if (t && nms.indexOf(t) < 0) nms.push(t); }); });
        (c.cart_level_discount_applications || []).forEach(function (a) { if (a.title && nms.indexOf(a.title) < 0) nms.push(a.title); });
        $('[data-desc-name]', dr2).textContent = nms.length ? nms.join(' + ') : 'Descuento'; }
      $('[data-cart-empty]', cd).hidden = !!n;
      cd.classList.toggle('is-empty', !n);
      $('[data-cart-items]', cd).innerHTML = c.items.map(function (x, i) { return lineHTML(x, i, 'cd-item'); }).join('');
      upsells();
    }
    var cpg = $('[data-cart-page]');
    if (cpg) {
      $('[data-cp-empty]', cpg).hidden = !!n;
      $('[data-cp-foot]', cpg).hidden = !n;
      $('[data-cp-items]', cpg).innerHTML = c.items.map(function (x, i) { return lineHTML(x, i, 'cp-item'); }).join('');
      $('[data-cp-total]', cpg).textContent = money(t) + ' ' + (c.currency || K.cur || '');
    }
  }
  /* "Te va a encantar": recomendaciones de Shopify del último producto añadido, solo de un modelo (se añaden con un clic) */
  var upFor = null, upList = [];
  function upsells() {
    var box = $('[data-upsells]', cd); if (!box || !CART) return;
    var items = CART.items; if (!items.length) { box.hidden = true; return; }
    var last = items[0], inCart = items.map(function (x) { return x.product_id; });
    var paint = function () {
      var pool = upList.filter(function (p) { return inCart.indexOf(p.id) < 0 && p.variants.length === 1 && p.variants[0].available; }).slice(0, 10);
      box.hidden = !pool.length;
      var addT = $('[data-upsell-list]', cd).getAttribute('data-add');
      $('[data-upsell-list]', cd).innerHTML = pool.map(function (p) {
        return '<li class="cd-up"><a href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 160)) + '" alt="" loading="lazy"></a><div><p>' + esc(p.title) + '</p>' +
          '<div class="up-row"><span>' + money(p.price) + '</span><button type="button" class="up-add" data-up="' + p.variants[0].id + '">' + esc(addT) + '</button></div></div></li>';
      }).join('');
    };
    if (upFor === last.product_id) return paint();
    upFor = last.product_id;
    /* Curso (estructura de tienda): en la cesta se ofrece un complemento barato de 15-20 € (joyería), nunca otra prenda */
    /* Él (5 oct): en el carrito, algo de 15-20 € que no duela pagar para completar la compra (joyas y accesorios de mujer) */
    fetch(root + '/collections/joyeria-y-accesorios?view=ks-extra&sort_by=best-selling').then(function (r) { return r.text(); }).then(function (t) {
      var jw = (JSON.parse(t).products || []).filter(function (p) { return p.price >= 1500 && p.price <= 2000; });
      upList = jw; paint(); /* nunca otra prenda: si no hay complementos de 15-20 €, no se ofrece nada */
    }).catch(function () { box.hidden = true; });
    function fallback() { return fetch((K.reco || '/recommendations/products') + '.json?product_id=' + last.product_id + '&limit=10&intent=related')
      .then(function (r) { return r.json(); }).then(function (j) {
        upList = (j.products || []).filter(function (p) { return p.variants.length === 1 && p.variants[0].available; });
        if (upList.length) return paint();
        /* tienda nueva sin recomendaciones todavía: productos de un solo modelo, primero los del mismo tipo */
        return fetch(root + '/collections/all?view=ks-extra&sort_by=created-descending').then(function (r) { return r.text(); }).then(function (t) {
          var ex = JSON.parse(t).products || [], ty = last.product_type;
          ex.sort(function (a, b) { return (b.type === ty) - (a.type === ty); });
          upList = ex; paint();
        });
      }).catch(function () { box.hidden = true; }); }
  }
  function cart(open) {
    if (!cd) return;
    cd.classList.toggle('open', open); cd.setAttribute('aria-hidden', !open);
    d.body.classList.toggle('menu-open', open);
    if (open) { menu(false); render(); getCart(); }
  }
  function add(id, q, btn) {
    if (busy) return Promise.resolve(); busy = true;
    var old = btn && btn.textContent; if (btn) { btn.disabled = true; }
    return api((K.cartAdd || '/cart/add') + '.js', { items: [{ id: id, quantity: q || 1 }] })
      .then(function () { return getCart(); }).then(function () { cart(true); })
      .catch(function (e) { var er = $('[data-add-err]'); if (er) { er.hidden = false; er.textContent = (e && (e.description || e.message)) || 'No se ha podido añadir.'; } })
      .then(function () { busy = false; if (btn) { btn.disabled = false; btn.textContent = old; } });
  }
  function change(line, q) {
    return api((K.cartChange || '/cart/change') + '.js', { line: line, quantity: Math.max(0, Math.min(99, q)) }).then(function (c) { CART = c; render(); });
  }
  $$('[data-open-cart]').forEach(function (a) {
    a.addEventListener('click', function (ev) { if ($('[data-cart-page]')) return; ev.preventDefault(); cart(true); });
  });
  d.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t.closest('[data-close-cart]')) { cart(false); return; }
    var li = t.closest('[data-line]');
    if (li && CART) {
      var x = CART.items[+li.getAttribute('data-line') - 1];
      if (x && t.closest('[data-ci]')) change(+li.getAttribute('data-line'), x.quantity + Number(t.closest('[data-ci]').getAttribute('data-ci')));
      if (x && t.closest('[data-ci-rm]')) change(+li.getAttribute('data-line'), 0);
    }
    var up = t.closest('[data-up]'); if (up) add(+up.getAttribute('data-up'), 1);
  });
  d.addEventListener('change', function (ev) {
    var inp = ev.target.closest('[data-ci-q]'); if (!inp) return;
    change(+inp.closest('[data-line]').getAttribute('data-line'), parseInt(inp.value, 10) || 0);
  });
  getCart();

  /* ---------------- tarjetas: puntos de color y añadir rápido ---------------- */
  d.addEventListener('click', function (ev) {
    var t = ev.target, cardEl = t.closest('.card'); if (!cardEl) return;
    var dot = t.closest('[data-dot]');
    if (dot) {
      $$('[data-dot]', cardEl).forEach(function (x) { x.classList.toggle('on', x === dot); });
      var src = dot.getAttribute('data-img'), im = $('.im1', cardEl);
      if (src && im) { im.removeAttribute('srcset'); im.src = src; }
      return;
    }
    var qb = t.closest('.card-quick');
    if (qb) {
      var open = !cardEl.classList.contains('q-open');
      $$('.card.q-open').forEach(function (c) { c.classList.remove('q-open'); $('.card-quick', c).setAttribute('aria-expanded', 'false'); });
      cardEl.classList.toggle('q-open', open); qb.setAttribute('aria-expanded', open);
      return;
    }
    var qs = t.closest('[data-qs]');
    if (qs && !$('[data-card-v]', cardEl)) {
      fetch((cardEl.getAttribute('data-url') || '') + '.js').then(function (r) { return r.json(); }).then(function (pr) {
        cardEl.insertAdjacentHTML('beforeend', '<script type="application/json" data-card-v>' + JSON.stringify(pr.variants.map(function (v) { return [v.id, v.option1, v.option2, v.option3, v.available ? 1 : 0]; })) + '<\/script><script type="application/json" data-card-o>' + JSON.stringify(pr.options.map(function (o) { return o.name || o; })) + '<\/script>');
        qs.click();
      });
      return;
    }
    if (qs) {
      var V = JSON.parse(($('[data-card-v]', cardEl) || {}).textContent || '[]'), O = JSON.parse(($('[data-card-o]', cardEl) || {}).textContent || '[]');
      var lo = O.map(function (o) { return String(o).toLowerCase(); });
      var ci = lo.findIndex(function (o) { return /^(color|colour|colores)$/.test(o); }), si = lo.findIndex(function (o) { return /^(talla|size|tallas|tamaño)$/.test(o); });
      var sd = $('.dot.on', cardEl), color = sd ? sd.getAttribute('data-dot') : null, size = qs.getAttribute('data-qs');
      var ok = function (v) { return (ci < 0 || !color || v[ci + 1] === color) && (si < 0 || !size || v[si + 1] === size); };
      var v = V.filter(function (x) { return ok(x) && x[4]; })[0] || V.filter(ok)[0];
      if (!v || !v[4]) { qs.classList.add('off'); return; }
      add(v[0], 1); cardEl.classList.remove('q-open');
    }
  });

  /* ---------------- ficha de producto ---------------- */
  var pj = $('#productJSON');
  if (pj) {
    var P = JSON.parse(pj.textContent), nO = P.options.length;
    var cur = (new URLSearchParams(location.search).get('variant')) || ($('[data-variant-id]') || {}).value;
    var v0 = P.variants.filter(function (v) { return String(v.id) === String(cur); })[0] || P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
    var sel = v0.o.slice(0, nO);
    /* Curso: «Elige tu talla». La talla no viene marcada; el botón lo pide hasta que la clienta elige (evita devoluciones por talla). */
    var szI = P.options.map(function (o) { return String(o).toLowerCase(); }).findIndex(function (o) { return /^(talla|size|tallas|tamaño)$/.test(o); });
    var szVals = szI < 0 ? [] : P.variants.map(function (v) { return v.o[szI]; }).filter(function (x, i, a) { return a.indexOf(x) === i; });
    var szOk = szI < 0 || szVals.length < 2 || !!new URLSearchParams(location.search).get('variant');
    var gm = $('#gMain'), gi = $('[data-g-i]'), form = $('[data-product-form]');
    var findV = function () { return P.variants.filter(function (v) { return sel.every(function (s, i) { return v.o[i] === s; }); })[0]; };
    function goImg(i, smooth) {
      if (!gm || !gm.children[i]) return;
      if (innerWidth >= 990) { if (smooth) { var y = gm.children[i].getBoundingClientRect().top + scrollY - 140; scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); } return; }
      gm.scrollTo({ left: gm.children[i].offsetLeft - gm.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }
    $$('.g-dots button').forEach(function (b) { b.addEventListener('click', function () { goImg(+b.getAttribute('data-i'), true); }); });
    gm && gm.addEventListener('scroll', function () {
      var i = Math.round(gm.scrollLeft / gm.clientWidth);
      if (gi) gi.textContent = i + 1;
      $$('.g-thumb, .g-dots button').forEach(function (b) { b.classList.toggle('on', +b.getAttribute('data-i') === i); });
    }, { passive: true });
    $$('.g-thumb').forEach(function (b) { b.addEventListener('click', function () { goImg(+b.getAttribute('data-i'), true); }); });
    function update(fromUser) {
      var v = findV();
      $$('.sw').forEach(function (b) {
        var oi = +b.getAttribute('data-opt'), val = b.getAttribute('data-val');
        var onB = sel[oi] === val && (oi !== szI || szOk);
        b.classList.toggle('on', onB); b.setAttribute('aria-pressed', onB);
        var test = sel.slice(); test[oi] = val;
        var ok = P.variants.some(function (x) { return x.available && test.every(function (s, i) { return x.o[i] === s; }); });
        b.classList.toggle('off', !ok);
      });
      sel.forEach(function (s, i) { var o = $('[data-selected="' + i + '"]'); if (o) o.textContent = (i === szI && !szOk) ? '' : s; });
      var btns = $$('[data-add],[data-add-sticky]'), T = K.t || {};
      if (!v || !v.available) { btns.forEach(function (b) { b.disabled = true; b.textContent = T.soldout || 'Agotado'; }); }
      else if (!szOk) { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Elige tu talla'; b.classList.add('is-elige'); }); }
      else { btns.forEach(function (b) { b.disabled = false; b.textContent = T.add || 'Añadir al carrito'; b.classList.remove('is-elige'); }); }
      if (v) {
        $$('[data-price]').forEach(function (p) { p.textContent = money(v.price); });
        var sale = v.cp > v.price;
        $$('[data-was]').forEach(function (e) { e.textContent = sale ? money(v.cp) : ''; e.hidden = !sale; });
        $$('[data-ahorro-p]').forEach(function (e) { e.textContent = sale ? ahorroTxt(v.price, v.cp) : 'Combínalo con otras prendas y ahorra hasta un 20 %'; e.hidden = false; e.classList.toggle('pr-vol', !sale); });
        $$('.p-price').forEach(function (e) { e.classList.toggle('is-sale', sale); });
        /* Precio de cada pack: 1 = precio; 2 = −10 %; 3 = −15 % (los descuentos automáticos del carrito) */
        [[1, 1], [2, .9], [3, .85]].forEach(function (k) { var e = $('[data-pk-p="' + k[0] + '"]'); if (e) e.textContent = money(Math.round(v.price * k[0] * k[1])); });
        $$('[data-variant-id],[data-pt-id]').forEach(function (i) { i.value = v.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
        if (fromUser) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {} }
      }
      var er = $('[data-add-err]'); if (er) er.hidden = true;
      if (fromUser && v && v.media) { var k = P.media.indexOf(v.media); if (k > -1) goImg(k, true); }
    }
    $$('.sw').forEach(function (b) { b.addEventListener('click', function () { var oi = +b.getAttribute('data-opt'); sel[oi] = b.getAttribute('data-val'); if (oi === szI) { szOk = true; var ft = $('[data-opt-talla]'); if (ft) ft.classList.remove('falta'); } update(true); }); });
    var qty = $('[data-qty]');
    $$('[data-q]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(99, (+qty.value || 1) + +b.getAttribute('data-q'))); }); });
    $$('[name="ks-pack"]').forEach(function (r) { r.addEventListener('change', function () { qty.value = r.value; $$('.pk').forEach(function (l) { l.classList.toggle('on', $('input', l).checked); }); }); });
    $$('.pk').forEach(function (l) { l.classList.toggle('on', $('input', l).checked); });
    function addCurrent(btn) {
      if (!szOk) { var ft = $('[data-opt-talla]'); if (ft) { ft.classList.remove('falta'); void ft.offsetWidth; ft.classList.add('falta'); scrollTo({ top: Math.max(0, ft.getBoundingClientRect().top + scrollY - 120), behavior: 'smooth' }); } return; }
      var v = findV(); if (!v || !v.available) return; add(v.id, Math.max(1, +qty.value || 1), btn); }
    form && form.addEventListener('submit', function (ev) { ev.preventDefault(); addCurrent($('[data-add]')); });
    var stb = $('[data-add-sticky]'); stb && stb.addEventListener('click', function () { addCurrent(stb); });
    update(false);
    var bb = $('#buyBar'), main = $('[data-add]');
    if (bb && main) {
      var bbTick = function () {
        var on = main.getBoundingClientRect().bottom < 0;
        bb.classList.toggle('on', on); bb.setAttribute('aria-hidden', !on); d.body.classList.toggle('bb-on', on && innerWidth < 990);
      };
      addEventListener('scroll', bbTick, { passive: true }); addEventListener('resize', bbTick); bbTick();
    }
  }

  /* ---------------- guía de tallas: ventana + cm/pulgadas (en España se abre en cm) ---------------- */
  var UKEY = 'karmaseda_unidades';
  var NO_CONV = /(talla|size|\beu\b|\bus\b|\buk\b|\bfr\b|\bit\b|copa|cup|edad|age|color)/i;
  function conv(t, u) { return t.replace(/\d+(?:[.,]\d+)?/g, function (n) { var v = parseFloat(n.replace(',', '.')); if (isNaN(v)) return n; var r = u === 'in' ? v / 2.54 : v * 2.54; return (Math.round(r * 10) / 10).toString().replace(/\.0$/, '').replace('.', ','); }); }
  function convCols(tb) { var heads = $$('tr:first-child th, tr:first-child td', tb); return heads.map(function (c, i) { return !(i === 0 || NO_CONV.test((c.textContent || '').trim())); }); }
  function apply(box, u) {
    var tb = $('table', box); if (!tb) return;
    var ok = convCols(tb);
    $$('tr', tb).forEach(function (tr, r) {
      [].forEach.call(tr.children, function (c, i) {
        if (r === 0 || c.tagName === 'TH' || !ok[i]) return;
        if (!c.hasAttribute('data-orig')) c.setAttribute('data-orig', c.textContent.trim());
        var o = c.getAttribute('data-orig');
        c.textContent = u === 'in' && /\d/.test(o) ? conv(o, 'in') : o;
      });
    });
    $$('.k-unidad', box).forEach(function (b) { var on = b.getAttribute('data-unidad') === u; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
  }
  $$('.k-tallas').forEach(function (box) {
    var tb = $('table', box); if (!tb || !convCols(tb).some(Boolean)) return;
    var bar = d.createElement('div'); bar.className = 'k-unidades';
    bar.innerHTML = '<span class="k-unidades-etq">Medidas en</span><div class="k-unidades-grupo" role="group" aria-label="Unidades"><button type="button" class="k-unidad" data-unidad="cm">cm</button><button type="button" class="k-unidad" data-unidad="in">pulgadas</button></div>';
    box.insertBefore(bar, box.firstChild);
    bar.addEventListener('click', function (ev) {
      var b = ev.target.closest('.k-unidad'); if (!b) return;
      var u = b.getAttribute('data-unidad'); store.set(UKEY, u); $$('.k-tallas').forEach(function (x) { apply(x, u); });
    });
    apply(box, store.get(UKEY, 'cm'));
  });
  var sg = $('#sizeGuide');
  function guide(open) { if (!sg) return; sg.hidden = !open; d.body.classList.toggle('menu-open', open); if (open) { var c = $('[data-close-guide].icon-btn', sg); c && c.focus(); } }
  $$('[data-open-guide]').forEach(function (b) { b.addEventListener('click', function () { guide(true); }); });
  $$('[data-close-guide]').forEach(function (b) { b.addEventListener('click', function () { guide(false); }); });

  /* ---------------- colección y búsqueda: filtros nativos, orden y carga continua ---------------- */
  function wireList(col) {
    var sec = col.getAttribute('data-section');
    var gridEl = $('[data-grid]', col);
    /* carga continua */
    var more = $('[data-next]', col), loading = false;
    function loadMore() {
      var nx = more && more.getAttribute('data-next'); if (!nx || loading) return;
      loading = true; more.classList.add('is-loading');
      fetch(nx + (nx.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sec).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var g = $('[data-grid]', doc), n = $('[data-next]', doc);
        if (g) { var frag = d.createDocumentFragment(); [].slice.call(g.children).forEach(function (c) { frag.appendChild(c); }); gridEl.appendChild(frag); reveal(gridEl); }
        more.setAttribute('data-next', n ? n.getAttribute('data-next') : '');
      }).catch(function () {}).then(function () { loading = false; more.classList.remove('is-loading'); check(); });
    }
    /* Curso: botón «Cargar más» en vez de cargar al bajar (así se llega al pie, donde están las políticas) */
    function upd() { var cb = $('[data-cargar]', col); if (!cb) return; var lg = $('[data-grid-local]', col), locOn = lg && !lg.hidden;
      cb.hidden = locOn ? !(col._locLeft && col._locLeft()) : !(more && more.getAttribute('data-next')); }
    function check() { upd(); }
    col.addEventListener('click', function (ev) { if (!ev.target.closest('[data-cargar]')) return; var lg = $('[data-grid-local]', col);
      if (lg && !lg.hidden) { col._locMore && col._locMore(); upd(); } else loadMore(); });
    setInterval(upd, 700);
    /* filtros */
    var form = $('[data-facets-form]', col); if (!form) return;
    if (col.hasAttribute('data-local-filters')) return localFilters(col, form, sec, gridEl, more);
    var mobileOpen = function () { return $('.facets', col) && $('.facets', col).classList.contains('is-open'); };
    function go(url) {
      var openF = $$('.facet[open]', col).map(function (x) { return x.getAttribute('data-facet'); }), mo = mobileOpen();
      col.classList.add('is-loading');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sec).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html'), nc = $('[data-collection]', doc);
        if (!nc) { location.href = url; return; }
        col.innerHTML = nc.innerHTML;
        openF.forEach(function (k) { var f = $('.facet[data-facet="' + k + '"]', col); if (f) f.open = true; });
        if (mo) $('.facets', col).classList.add('is-open');
        try { history.replaceState(history.state, '', url); } catch (e) {}
        col.classList.remove('is-loading');
        reveal(col); wireList(col);
      }).catch(function () { location.href = url; });
    }
    function urlFromForm() {
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      return col.getAttribute('data-url') + '?' + p.toString();
    }
    var pt;
    form.addEventListener('change', function (ev) { if (ev.target.type === 'number') return; go(urlFromForm()); });
    form.addEventListener('input', function (ev) { if (ev.target.type !== 'number') return; clearTimeout(pt); pt = setTimeout(function () { go(urlFromForm()); }, 700); });
    form.addEventListener('submit', function (ev) { ev.preventDefault(); go(urlFromForm()); });
    col.addEventListener('click', function (ev) {
      var r = ev.target.closest('[data-reset]');
      if (r) {
        var k = r.getAttribute('data-reset');
        if (k === 'price') $$('input[type=number]', form).forEach(function (i) { i.value = ''; });
        else $$('input[type=checkbox]', form).forEach(function (i) { if (i.name === k) i.checked = false; });
        go(urlFromForm()); return;
      }
      var g = ev.target.closest('[data-go]'); if (g) { go(g.getAttribute('data-go')); return; }
      if (ev.target.closest('[data-open-facets]')) {
        var fc = $('.facets', col), open = !fc.classList.contains('is-open');
        fc.classList.toggle('is-open', open); d.body.classList.toggle('menu-open', open);
      }
    });
  }

  /* Filtros calculados en el navegador (mismos que la tienda local) mientras la tienda no tenga filtros nativos */
  var SORD = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  function sizeKey(v) { var u = String(v).toUpperCase(), i = SORD.indexOf(u); if (i > -1) return [0, i]; var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? [2, 0, v] : [1, n]; }
  /* Estrellas de Judge.me en la tarjeta (mismo dibujo que snippets/ks-stars.liquid); solo si hay reseñas y nunca en la portada */
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.6l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.5l-5.9 3.1 1.2-6.5-4.8-4.6 6.6-.9z"/></svg>';
  function starsHTML(r, n) {
    r = +r || 0; n = +n || 0; if (!(n > 0) || d.body.classList.contains('tpl-index')) return '';
    var s5 = STAR + STAR + STAR + STAR + STAR, px = Math.max(0, Math.round(r * 2) * 8 - 1);
    return '<p class="card-stars" aria-label="Valoración ' + (Math.round(r * 10) / 10).toString().replace('.', ',') + ' de 5 · ' + n + (n === 1 ? ' opinión' : ' opiniones') + '"><span class="cs-s" aria-hidden="true"><span class="cs-off">' + s5 + '</span><span class="cs-on" style="width:' + px + 'px">' + s5 + '</span></span><span class="cs-n" aria-hidden="true">(' + n + ')</span></p>';
  }
  function cardFromData(p) {
    var dots = '';
    if (p.co.length > 1) dots = '<ul class="card-dots">' + p.co.slice(0, 4).map(function (c, i) {
      return '<li><button type="button" class="dot' + (i ? '' : ' on') + '" data-dot="' + esc(c[0]) + '" data-img="' + esc(c[1]) + '" aria-label="' + esc(c[0]) + '" title="' + esc(c[0]) + '">' + (c[1] ? '<img src="' + esc(img(c[1], 60)) + '" alt="" loading="lazy" width="16" height="16">' : '') + '</button></li>';
    }).join('') + (p.co.length > 4 ? '<li class="dot-more">+' + (p.co.length - 4) + '</li>' : '') + '</ul>';
    var q = p.s.length ? '<p class="cq-h">' + esc(p.sn) + '</p><div class="cq-sizes notranslate" translate="no">' + p.s.map(function (z) { return '<button type="button" data-qs="' + esc(z) + '">' + esc(z) + '</button>'; }).join('') + '</div>'
      : '<button type="button" class="cq-add" data-qs="">' + esc((K.t && K.t.add) || 'Añadir al carrito') + '</button>';
    return '<li class="card reveal in" data-h="' + esc(p.h) + '" data-url="' + esc(p.u) + '"><div class="card-mw">' + (p.cp > p.p ? '<span class="card-ahorro notranslate" translate="no">Ahorras ' + money(p.cp - p.p) + '</span>' : '') + '<a class="card-media" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
      (p.i ? '<img class="im1" src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy" width="800" height="800">' : '') + (p.i2 ? '<img class="im2" src="' + esc(p.i2) + '" alt="" loading="lazy" width="800" height="800">' : '') +
      '</a><button type="button" class="card-quick" aria-label="' + esc(((K.t && K.t.add) || 'Añadir al carrito') + ' · ' + p.t) + '" aria-expanded="false">' + ICON.plus + '</button><div class="card-q">' + q + '</div></div>' +
      '<div class="card-info"><a class="card-title" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' + starsHTML(p.r, p.rc) + priceHTML(p.p, p.cp) + dots + '</div></li>';
  }
  function localFilters(col, form, sec, gridEl, more) {
    var DATA = col._ksData || null, loading = null, localGrid = $('[data-grid-local]', col), list = [], shown = 0;
    var base = col.getAttribute('data-url');
    function load() {
      if (DATA) return Promise.resolve(DATA);
      if (loading) return loading;
      var all = [], page = function (n) {
        return fetch(base + '?view=ks-datos&page=' + n).then(function (r) { return r.text(); }).then(function (t) { var j = JSON.parse(t); all = all.concat(j.p); return n < j.n ? page(n + 1) : all; });
      };
      loading = page(1).then(function (a) { DATA = col._ksData = a; paintLists(); return a; });
      return loading;
    }
    function paintLists() {
      var colors = {}, sizes = {}, maxp = 0;
      DATA.forEach(function (p) { p.co.forEach(function (c) { colors[c[0]] = (colors[c[0]] || 0) + 1; }); p.s.forEach(function (z) { sizes[z] = (sizes[z] || 0) + 1; }); if (p.p > maxp) maxp = p.p; });
      var st = state();
      var li = function (name, v, n) { return '<li><label class="fchk"><input type="checkbox" name="' + name + '" value="' + esc(v) + '"' + (st[name].indexOf(v) > -1 ? ' checked' : '') + '><span>' + esc(v) + ' (' + n + ')</span></label></li>'; };
      var cl = $('[data-list="color"]', col), sl = $('[data-list="size"]', col);
      if (cl) cl.innerHTML = Object.keys(colors).sort(function (a, b) { return a.localeCompare(b, 'es'); }).map(function (v) { return li('color', v, colors[v]); }).join('');
      if (sl) sl.innerHTML = Object.keys(sizes).sort(function (a, b) { var x = sizeKey(a), y = sizeKey(b); return x[0] - y[0] || (x[1] - y[1]) || String(a).localeCompare(b); }).map(function (v) { return li('size', v, sizes[v]); }).join('');
      var mt = $('[data-pmax-t]', col); if (mt) mt.textContent = money(maxp);
      $$('input[name=pmin],input[name=pmax]', col).forEach(function (i) { i.max = Math.ceil(maxp / 100); if (i.name === 'pmax') i.placeholder = (maxp / 100).toFixed(2).replace('.', MM ? MM[2] : '.'); });
    }
    function state() {
      var s = { color: [], size: [], pmin: null, pmax: null };
      $$('input[type=checkbox]:checked', form).forEach(function (i) { if (s[i.name]) s[i.name].push(i.value); });
      var a = ($('input[name=pmin]', form) || {}).value, b = ($('input[name=pmax]', form) || {}).value;
      s.pmin = a ? +String(a).replace(',', '.') * 100 : null; s.pmax = b ? +String(b).replace(',', '.') * 100 : null;
      s.any = s.color.length || s.size.length || s.pmin != null || s.pmax != null;
      return s;
    }
    function sortList(arr) {
      var v = ($('select[name=sort_by]', form) || {}).value;
      var cmp = {
        'title-ascending': function (a, b) { return a.t.localeCompare(b.t, 'es'); }, 'title-descending': function (a, b) { return b.t.localeCompare(a.t, 'es'); },
        'price-ascending': function (a, b) { return a.p - b.p; }, 'price-descending': function (a, b) { return b.p - a.p; },
        'created-ascending': function (a, b) { return a.c - b.c; }, 'created-descending': function (a, b) { return b.c - a.c; }
      }[v];
      return cmp ? arr.slice().sort(cmp) : arr;
    }
    function more24() { var chunk = list.slice(shown, shown + 24); localGrid.insertAdjacentHTML('beforeend', chunk.map(cardFromData).join('')); shown += chunk.length; }
    function run() {
      var s = state();
      ['color', 'size'].forEach(function (k) { var f = $('[data-facet=' + k + '] [data-count]', col); if (f) f.textContent = s[k].length; });
      var pills = [];
      s.color.concat(s.size).forEach(function (v) { pills.push({ v: v, t: v }); });
      if (s.pmin != null || s.pmax != null) pills.push({ v: '__price', t: money(s.pmin || 0) + '–' + (s.pmax != null ? money(s.pmax) : '') });
      var box = $('[data-active]', col); box.hidden = !pills.length;
      $('[data-pills]', col).innerHTML = pills.map(function (p) { return '<li><button type="button" data-pill="' + esc(p.v) + '">' + esc(p.t) + ICON.x + '</button></li>'; }).join('');
      if (!s.any) {
        localGrid.hidden = true; localGrid.innerHTML = ''; gridEl.hidden = false; if (more) more.hidden = false;
        $$('[data-n]', col).forEach(function (x) { x.textContent = col.getAttribute('data-total'); });
        return;
      }
      load().then(function () {
        var st = state();
        list = sortList(DATA.filter(function (p) {
          var cc = p.co.map(function (c) { return c[0]; });
          return (!st.color.length || st.color.some(function (x) { return cc.indexOf(x) > -1; })) && (!st.size.length || st.size.some(function (x) { return p.s.indexOf(x) > -1; })) &&
            (st.pmin == null || p.p >= st.pmin) && (st.pmax == null || p.p <= st.pmax);
        }));
        $$('[data-n]', col).forEach(function (x) { x.textContent = list.length; });
        gridEl.hidden = true; if (more) more.hidden = true; localGrid.hidden = false; localGrid.innerHTML = ''; shown = 0; more24();
      });
    }
    col._locMore = more24; col._locLeft = function () { return shown < list.length; };
    $$('.facet[data-local]', col).forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) load(); }); });
    col.addEventListener('mouseover', function (ev) { if (ev.target.closest('.facets')) load(); });
    var pt;
    form.addEventListener('submit', function (ev) { ev.preventDefault(); });
    form.addEventListener('change', function (ev) {
      if (ev.target.name === 'sort_by') {
        if (state().any) return run();
        col.classList.add('is-loading');
        fetch(base + '?sort_by=' + encodeURIComponent(ev.target.value) + '&section_id=' + sec).then(function (r) { return r.text(); }).then(function (h) {
          var doc = new DOMParser().parseFromString(h, 'text/html'), g = $('[data-grid]', doc), n = $('[data-next]', doc);
          if (g) gridEl.innerHTML = g.innerHTML; if (more) more.setAttribute('data-next', n ? n.getAttribute('data-next') : '');
          try { var u = new URL(location.href); u.searchParams.set('sort_by', ev.target.value); u.searchParams.delete('page'); history.replaceState(history.state, '', u); } catch (e) {}
          col.classList.remove('is-loading'); reveal(gridEl);
        });
        return;
      }
      if (ev.target.type !== 'number') run();
    });
    form.addEventListener('input', function (ev) { if (ev.target.type !== 'number') return; clearTimeout(pt); pt = setTimeout(run, 500); });
    col.addEventListener('click', function (ev) {
      var r = ev.target.closest('[data-reset]');
      if (r) {
        var k = r.getAttribute('data-reset');
        $$('input[type=checkbox]', form).forEach(function (i) { if (k === 'all' || i.name === k) i.checked = false; });
        if (k === 'all' || k === 'price') $$('input[type=number]', form).forEach(function (i) { i.value = ''; });
        run(); return;
      }
      var p = ev.target.closest('[data-pill]');
      if (p) {
        var v = p.getAttribute('data-pill');
        if (v === '__price') $$('input[type=number]', form).forEach(function (i) { i.value = ''; });
        else $$('input[type=checkbox]', form).forEach(function (i) { if (i.value === v) i.checked = false; });
        run(); return;
      }
      var g = ev.target.closest('[data-go]'); if (g) { ev.preventDefault(); $$('input[type=checkbox]', form).forEach(function (i) { i.checked = false; }); $$('input[type=number]', form).forEach(function (i) { i.value = ''; }); run(); return; }
      if (ev.target.closest('[data-open-facets]')) {
        var fc = $('.facets', col), open = !fc.classList.contains('is-open');
        fc.classList.toggle('is-open', open); d.body.classList.toggle('menu-open', open);
      }
    });
    if ('requestIdleCallback' in window) requestIdleCallback(function () { load(); }, { timeout: 4000 }); else setTimeout(load, 2500);
  }
  $$('[data-collection],[data-search-page]').forEach(wireList);

  /* ---------------- páginas de texto: índice numerado 1/2/3 y detalles de la V1 Oro ---------------- */
  var slug = function (t) { return String(t).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || 'sec'; };
  function enhancePage(main) {
    var h = main.getAttribute('data-page') || '', inner = main.firstElementChild && !main.firstElementChild.matches('details') ? main.firstElementChild : main;
    /* entradilla, listas y pasos con las clases de la V1 Oro */
    $$('.k-intro', inner).forEach(function (p) { p.classList.add(inner.classList.contains('k-pago') ? 'k-pago-lede' : 'k-info-lede'); });
    if (inner.classList.contains('k-info')) $$(':scope > ul:not([class])', inner).forEach(function (u) { u.classList.add('k-info-facts'); });
    if (inner.classList.contains('k-pago')) $$(':scope > ul:not([class])', inner).forEach(function (u) { u.classList.add('k-pago-facts'); });
    $$(':scope > ol:not([class])', inner).forEach(function (ol) {
      ol.classList.add('k-pasos');
      $$(':scope > li', ol).forEach(function (li) {
        var s = li.firstElementChild;
        var pre = li.firstChild; while (pre && pre !== s && pre.nodeType === 3 && !pre.textContent.trim()) pre = pre.nextSibling;
        if (s && s.tagName === 'STRONG' && pre === s) {
          var t = s.textContent.replace(/[.:]\s*$/, ''); s.remove();
          li.innerHTML = '<h3>' + esc(t) + '</h3><p>' + li.innerHTML.trim() + '</p>';
        }
      });
    });
    /* títulos numerados a mano ("1. Comunícanos…"): el número lo pone el índice */
    $$('h2', inner).forEach(function (x) { x.innerHTML = x.innerHTML.replace(/^\s*\d+\.\s+/, ''); });
    /* Sobre nosotros: los 3 valores en tarjetas */
    if (h === 'about-us') {
      var hs = $$(':scope > h2', inner);
      if (hs.length) {
        var box = d.createElement('div'); box.className = 'k-valores'; hs[0].parentNode.insertBefore(box, hs[0]);
        hs.forEach(function (x) { var p = x.nextElementSibling, v = d.createElement('div'); v.className = 'k-valor';
          /* foto opcional del cuadro: un párrafo que solo lleva la imagen, justo después del título */
          if (p && p.tagName === 'P' && p.querySelector('img') && !p.textContent.trim()) { var fi = d.createElement('div'); fi.className = 'k-valor-img'; fi.appendChild(p.querySelector('img')); var sig = p.nextElementSibling; p.remove(); p = sig; v.appendChild(fi); }
          var h3 = d.createElement('h3'); h3.innerHTML = x.innerHTML; v.appendChild(h3); if (p && p.tagName === 'P') v.appendChild(p); x.remove(); box.appendChild(v); });
      }
    }
    /* Contacto: la lista de enlaces de "mira aquí primero" en tarjetas */
    if (h === 'contact') {
      $$(':scope > ul', inner).forEach(function (u) {
        var lis = $$(':scope > li', u); if (!lis.length || !lis.every(function (li) { return li.firstElementChild && li.firstElementChild.tagName === 'A'; })) return;
        var w = d.createElement('div'); w.className = 'k-contacto-tarjetas';
        lis.forEach(function (li) { var a = li.firstElementChild, rest = li.innerHTML.replace(a.outerHTML, '').trim();
          w.insertAdjacentHTML('beforeend', '<a class="k-contacto-card" href="' + esc(a.getAttribute('href')) + '"><span class="k-contacto-card-t">' + esc(a.textContent.replace(/[.]\s*$/, '')) + '</span><span class="k-contacto-card-p">' + rest + '</span></a>'); });
        u.replaceWith(w);
      });
      var cf = $('.contact-form', main); if (cf) main.appendChild(cf);
    }
    /* Pago seguro: la píldora de la moneda va con el título y las marcas reales debajo de "Cómo puedes pagar" */
    if (h === 'payment-methods') {
      var pill = $('.k-pago-pill', inner), cab = $('.k-pago-cab'); if (pill && cab) cab.appendChild(pill);
      var mk = $('[data-pago-marcas]', main), h2 = $('h2', inner);
      if (mk && h2) { var after = h2.nextElementSibling && h2.nextElementSibling.tagName === 'P' ? h2.nextElementSibling : h2; after.insertAdjacentElement('afterend', mk); mk.hidden = false; }
    }
    /* índice */
    var items = [], used = {};
    var uid = function (t) { var b = slug(t), u = b, k = 2; while (used[u] || (d.getElementById(u) && !used[u] && false)) { u = b + '-' + k++; } used[u] = 1; return u; };
    if (main.classList.contains('policy')) {
      /* políticas: títulos numerados en negrita ("1. …"), con su propio número, como la local */
      var PH = /^\s*([0-9]{1,2}|[A-Z])\.\s+/, ph = $$('p', inner).filter(function (p) { var t = p.textContent.trim(), s = p.querySelector('strong,b'); return s && t === s.textContent.trim() && PH.test(t) && t.length < 120; });
      if (ph.length > 1) {
        var its = ph.map(function (p) {
          var t = p.textContent.trim(), n = t.match(PH)[1], tt = t.replace(PH, ''), id = uid(tt);
          p.id = id; p.classList.add('sec-h'); var s = p.querySelector('strong,b');
          s.innerHTML = '<span class="sec-n">' + n + '.</span> ' + esc(tt);
          return [id, n, tt];
        });
        var lis2 = its.map(function (it) { return '<li><a href="#' + it[0] + '"><span class="toc-n">' + it[1] + '</span><span class="toc-t">' + esc(it[2]) + '</span></a></li>'; }).join('');
        var side2 = $('.pw-side'); if (side2) side2.insertAdjacentHTML('beforeend', '<nav class="ed-toc" aria-label="Índice"><ol>' + lis2 + '</ol></nav>');
        main.insertAdjacentHTML('afterbegin', '<details class="acc toc-m"><summary><span>Índice</span><span class="acc-mas" aria-hidden="true"></span></summary><div class="acc-a"><ol class="toc-list">' + lis2 + '</ol></div></details>');
        return;
      }
    }
    var heads = $$('h2', inner).filter(function (x) { return !x.classList.contains('sr'); });
    if (!heads.length) heads = $$('.k-valor h3', inner);
    if (!heads.length) heads = $$('h3', inner);
    heads.forEach(function (x, i) {
      var t = x.textContent.replace(/^\s*\d+\.\s*/, '').trim(), id = x.id || uid(t); x.id = id;
      if (!$('.sec-n', x)) x.insertAdjacentHTML('afterbegin', '<span class="sec-n">' + (i + 1) + '</span>');
      items.push([id, String(i + 1), t]);
    });
    if (items.length > 1) {
      var lis = items.map(function (it) { return '<li><a href="#' + it[0] + '"><span class="toc-n">' + it[1] + '</span><span class="toc-t">' + esc(it[2]) + '</span></a></li>'; }).join('');
      var side = $('.pw-side');
      if (side) side.insertAdjacentHTML('beforeend', '<nav class="ed-toc" aria-label="Índice"><ol>' + lis + '</ol></nav>');
      main.insertAdjacentHTML('afterbegin', '<details class="acc toc-m"><summary><span>Índice</span><span class="acc-mas" aria-hidden="true"></span></summary><div class="acc-a"><ol class="toc-list">' + lis + '</ol></div></details>');
    }
  }
  $$('[data-ks-toc]').forEach(enhancePage);
  var toc = $$('.ed-toc a');
  if (toc.length) {
    var secs = toc.map(function (a) { return d.getElementById(a.getAttribute('href').slice(1)); });
    var tocTick = function () {
      var k = 0; secs.forEach(function (h, i) { if (h && h.getBoundingClientRect().top < 180) k = i; });
      toc.forEach(function (a, i) { a.classList.toggle('on', i === k); });
    };
    addEventListener('scroll', tocTick, { passive: true }); tocTick();
  }
})();
